module.exports = __webpack_public_path__ + "4d0e3bb8ebabf71e59fade17baeb6dae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/works/one_page_slide_Mercy-Garden-Retour-Skin.jpg
// module id = 887
// module chunks = 0